export default __webpack_public_path__ + "images/student/unsupported-screen-back-a6837d54e196e2d0c7242480ac021935.jpg";